import axios from "axios";
import {
  ACCESS_TOKEN,
  DEVICE_DESKTOP,
  DEVICE_MOBILE,
  TOTAL_REQUEST,
  VERIFY_OTP_ERROR_CODES,
  WIDTH_IPAD,
} from "../common/constant";
import { rootUrl } from "../common/index";
import { IResponse } from "../models/base";
import {
  HTTP_METHOD_POST,
  HTTP_METHOD_PUT,
  // ROUTES_PATH,
  HTTP_METHOD_DELETE,
} from "../utils/constant";
import i18n from "../i18n";

const { innerWidth } = window;

const fetchTools = axios.create({
  baseURL: rootUrl,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Access-Control-Allow-Credentials": true,
    "x-device": DEVICE_DESKTOP,
    "x-screen": innerWidth > WIDTH_IPAD ? DEVICE_DESKTOP : DEVICE_MOBILE
  },
});

fetchTools.interceptors.request.use(
  async (config) => {
    config.headers["x-language"] = i18n.language;
    const token = localStorage.getItem(ACCESS_TOKEN);
    if (token) {
      config.headers["Authorization"] = token;
    }
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

export const configAxiosInterceptors = (
  callbackRequest: Function,
  callbackResponse: Function
) => {
  fetchTools.interceptors.request.use(async (config) => {
    const totalRequest = parseInt(localStorage.getItem(TOTAL_REQUEST) || "0");
    if (totalRequest < 0) {
      localStorage.setItem(TOTAL_REQUEST, "0");
    }
    localStorage.setItem(TOTAL_REQUEST, (totalRequest + 1).toString());

    config.headers["x-language"] = i18n.language;
    const token = localStorage.getItem(ACCESS_TOKEN);
    if (token) {
      config.headers["Authorization"] = token;
    }
    if (callbackRequest && totalRequest >= 0) {
      callbackRequest();
    }
    return config;
  });

  // fetchTools.interceptors.response.use(undefined, function (err) {
  //   return new Promise(function (resolve, reject) {
  //     if (err.response.status === 403 || err.response.status === 401) {
  //     }
  //     throw err.response.data;
  //   });
  // });

  fetchTools.interceptors.response.use(
    (config) => {
      const totalRequest = parseInt(localStorage.getItem(TOTAL_REQUEST) || "0");
      localStorage.setItem(TOTAL_REQUEST, (totalRequest - 1).toString());

      if (callbackResponse && totalRequest - 1 <= 0) {
        callbackResponse();
      }
      return config;
    },
    function (err) {
      const totalRequest = parseInt(localStorage.getItem(TOTAL_REQUEST) || "0");
      localStorage.setItem(TOTAL_REQUEST, (totalRequest - 1).toString());
      return new Promise(function (resolve, reject) {
        if (callbackResponse) {
          callbackResponse();
        }
        if (
          err.response.status === 400 &&
          VERIFY_OTP_ERROR_CODES[err.response?.data?.data?.code]
        ) {
          return resolve(err.response);
        }
        if (err.response.status === 403 || err.response.status === 401) {
          //TODO define logic unauthorize
          // clearUserInfo();
          // cleanToken();
          // setTimeout(() => {
          //     window.location.href = ROUTES_PATH.user_login;
          // }, 500);
        }
        throw err.response.data;
      });
    }
  );
};

// axios.interceptors.response.use(undefined, function (err) {
//     return new Promise(function (resolve, reject) {
//         if (err.response) {
//             throw err.response.data;
//         } else if (err.request) {
//             const error = new Error(i18n.t('app_network_disconnect'));
//             throw error;
//         }
//     });
// });

export const checkStatus = (response: IResponse<any>) => {
  if (response.status >= 200 && response.status <= 400) {
    return response;
  } else {
    const error = new Error(response.statusText);
    // error.response = response;
    throw error;
  }
};

export const parseJSON = (response: IResponse<any>) => {
  return response.data;
};

export function callApi<T>(
  method: string,
  api: string,
  data: any
): Promise<IResponse<T>> {
  let callApi = null;
  switch (method) {
    case HTTP_METHOD_POST:
      callApi = fetchTools.post(api, data);
      break;
    case HTTP_METHOD_PUT:
      callApi = fetchTools.put(api, data);
      break;
    case HTTP_METHOD_DELETE:
      callApi = fetchTools.delete(api, { params: data });
      break;
    default:
      callApi = fetchTools.get(api, { params: data });
      break;
  }

  return callApi
    .then(checkStatus)
    .then(parseJSON)
    .catch((error) => Promise.reject(error));
}

export default fetchTools;
